import { TENANT } from '../../tenant/tenantTypes'

export const EXPERIMENT_EXIT_INTENT_POPUP = {
  [TENANT.AT]: { desktop: 'cro-3105', mobile: 'cro-3104' },
  [TENANT.CH]: { desktop: 'cro-3110', mobile: 'cro-3111' },
  [TENANT.COM]: { desktop: 'cro-3102', mobile: 'cro-3103' },
  [TENANT.FR]: { desktop: 'cro-3109', mobile: 'cro-3108' },
  [TENANT.IT]: { desktop: 'cro-3106', mobile: 'cro-3107' },
}

export const EXPERIMENT_NAME_FREE_GIFT_PROMOTION = {
  [TENANT.AT]: 'cro-3279',
  [TENANT.BE]: 'cro-3856',
  [TENANT.CH]: 'cro-3282',
  [TENANT.COM]: 'cro-3278',
  [TENANT.FR]: 'cro-3281',
  [TENANT.IT]: 'cro-3280',
}

export const EXPERIMENT_AFTER_QUERY_SUGGEST_LAYER = {
  [TENANT.AT]: 'cro-3885',
  [TENANT.BE]: 'cro-3886',
  [TENANT.CH]: 'cro-3889',
  [TENANT.COM]: 'cro-3883',
  [TENANT.FR]: 'cro-3888',
  [TENANT.IT]: 'cro-3887',
}

export const EXPERIMENT_HEADER_STICKY_TOGGLE = {
  [TENANT.AT]: 'cro-4790',
  [TENANT.BE]: 'cro-4793',
  [TENANT.CH]: 'cro-4794',
  [TENANT.COM]: 'cro-4789',
  [TENANT.FR]: 'cro-4792',
  [TENANT.IT]: 'cro-4791',
}

export const EXPERIMENT_NEWSLETTER_MODAL = {
  [TENANT.CH]: {
    desktop: 'cro-4137',
    mobile: 'cro-4137',
  },
  [TENANT.FR]: {
    desktop: 'cro-4655',
    mobile: 'cro-4655',
  },
  [TENANT.IT]: {
    desktop: 'cro-4887',
    mobile: 'cro-4887',
  },
}

export const EXPERIMENT_OWN_BRANDS_OVERLAY = {
  [TENANT.AT]: 'cro-3777',
  [TENANT.IT]: 'cro-3778',
}
